/**
 * Normalizes a partner-supplied phone number into the digits-only shape our
 * form schemas expect.
 *
 * Partners prepopulate `userPhoneNumber` in the qual and do not agree on a
 * format: we see `+12985555555`, `298-555-5555` and `+1 (298) 555-5555` in the
 * wild.  The lead mode schema validates against digits only, so anything with
 * punctuation or a country code fails validation and leaves Submit disabled --
 * invisibly, because the masked input still *displays* the number correctly.
 *
 * This only reformats; it never repairs.  A number that isn't a valid 10 digit
 * NANP number stays invalid so the customer is asked to correct it, rather than
 * being padded or truncated into a different number.
 */
export function normalizePhoneNumber(value?: string): string | undefined {
  if (!value) return value;

  const digits = value.replace(/\D/g, '');

  // Strip the country code only when doing so leaves exactly 10 digits, so a
  // leading 1 in a malformed number isn't mistaken for a country code.
  if (digits.length === 11 && digits.startsWith('1')) {
    return digits.slice(1);
  }

  return digits;
}
